import React from 'react';
import UserManagementComponent from '../../../components/admin/user/UserManagementComponent';

const UserManagement: React.FC = () => {
  return <UserManagementComponent />;
};

export default UserManagement;
